export default __webpack_public_path__ + "media/brands/squarespace-31a00477.png";